import { categoryArea } from './modules/category_area'
import { moneyTree } from './modules/money_tree'
import { cmsModule } from './modules/cms_module'
import { cmsPage } from './modules/cms_page'
import { appDownload, appOpen } from './modules/app_download'
import { similarGoods } from './modules/similar_goods'
import { couponCenter } from './modules/coupon_center'
import { hotSaleList } from './modules/hotSale_list'
import { newGoodReq } from './modules/new_good_req'
import { bill } from './modules/bill'
import { activityGoods } from './modules/activity_goods'
import { deliverOrderList } from './modules/deliver_order_list'
import { deliverOrderDetail } from './modules/deliver_order_detail'
import { pop } from './modules/pop'
import { freight } from './modules/freight'
import { quarantine } from './modules/quarantine'
import { memberIndex } from './modules/memberIndex'
import { memberBuyLIst } from './modules/memberBuyLIst'
import { orderCancel } from './modules/cancel_order'
import { inspectReport } from './modules/inspectReport'
import { memberIntegral } from './modules/memberIntegral'
import { memberCouponpack } from './modules/memberCouponpack'
import { userChangePrice } from './modules/user_change_price'
import { goodRank } from './modules/good_randk'
import { demandwordRank } from './modules/demand_word'
import { activityArea } from './modules/activity_area'
import { homeGoods } from './modules/home_goods'
import { keyBox } from './modules/key_box'

export const trackMap = {
  moneyTree,
  cmsModule,
  cmsPage,
  appDownload,
  appOpen,
  similarGoods,
  couponCenter,
  hotSaleList,
  bill,
  categoryArea,
  activityGoods,
  deliverOrderList,
  deliverOrderDetail,
  pop,
  freight,
  newGoodReq,
  quarantine,
  memberIndex,
  memberBuyLIst,
  orderCancel,
  inspectReport,
  memberIntegral,
  memberCouponpack,
  userChangePrice,
  goodRank,
  demandwordRank,
  activityArea,
  homeGoods,
  keyBox
}
